import { Button } from '@components/ui/button';
import type { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

type MeiaPhaseAdvanceBarLink = {
  children: ReactNode;
  to: string;
};

type MeiaPhaseAdvanceBarProps = {
  backLink?: MeiaPhaseAdvanceBarLink;
  caption: ReactNode;
  forwardLink: MeiaPhaseAdvanceBarLink;
  title: ReactNode;
};

export const MeiaPhaseAdvanceBar: FC<MeiaPhaseAdvanceBarProps> = (props) => {
  const { backLink, caption, forwardLink, title } = props;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-5 py-3 shadow-sm">
      <div className="text-xs">
        <div className="font-medium text-gray-900">{title}</div>
        <div className="mt-0.5 text-gray-500">{caption}</div>
      </div>
      <div className="flex items-center gap-2">
        {backLink && (
          <Button
            asChild
            variant="outline"
          >
            <Link to={backLink.to}>{backLink.children}</Link>
          </Button>
        )}
        <Button asChild>
          <Link to={forwardLink.to}>{forwardLink.children}</Link>
        </Button>
      </div>
    </div>
  );
};
